import React, { Component } from 'react';

import { isMacOs, isSafari, isDesktop } from 'react-device-detect';
import classes from './StepThree.module.css';
import strings from '../../../../../assets/localization';
import Button from '../../../../UI/Button/Button';
import Input from '../../../../UI/Input/Input';
import InputError from '../../../../UI/InputError/InputError';
import { sanitizeAgeInput } from '../../../../../assets/helpers/utils';

export default class StepThree extends Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.state = {
      isEmpty: true,
      currentAge: '',
      hasAgeError: false,
    };
  }

  componentDidMount() {
    if (this.props.age === 0) {
      this.textInput.focus();
    }
  }

  _handleKeyDown = (e) => {
    if (e.keyCode === 13 && this._validateAge()) {
      this.props.goToStep(4);
    }
  };

  _onChange = (e) => {
    const {
      target: { value },
    } = e;

    // Sanitize input to only allow numbers and max 2 digits
    const sanitizedValue = sanitizeAgeInput(value);

    // Set the sanitized age value
    this.props.setAge(sanitizedValue);

    // Reset error state since we're sanitizing the input
    this.setState({ hasAgeError: false });

    const ageLength = sanitizedValue.length;
    if (ageLength >= 1) {
      this.setState({ isEmpty: false });
    } else {
      this.setState({ isEmpty: true });
    }
  };

  _validateAge = () => {
    const { minAge, maxAge, age } = this.props;
    return parseInt(age) >= minAge && parseInt(age) <= maxAge;
  };

  _renderAgeError = () => {
    const { isEmpty } = this.state;
    let ageError = this.state.hasAgeError
      ? strings.EnterYourAge
      : strings.ageError
          .replace('<', this.props.minAge)
          .replace('>', this.props.maxAge);

    return (
      <InputError
        style={{
          display:
            !isEmpty && (!this._validateAge() || this.state.hasAgeError)
              ? 'block'
              : 'none',
        }}
      >
        {ageError}
      </InputError>
    );
  };

  render() {
    // console.log('STEP 3 RENDER:', this.props, this.state);
    const { age } = this.props;

    return (
      <div className={classes.StepThree}>
        <div className={classes.InputWrapper}>
          <Input
            setRef={(component) => (this.textInput = component)}
            type={isDesktop ? 'text' : 'tel'}
            pattern='[0-9]*'
            inputMode='numeric'
            value={age !== 0 ? age : ''}
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
            onChange={this._onChange}
            label={strings.EnterYourAge}
            onKeyDown={this._handleKeyDown}
            inputLabelStyle={{
              fontSize: '0.8125rem',
              fontWeight: 'var(--font-weight-normal)',
              textAlign: 'left',
              paddingTop: '0',
              width: '100%',
              marginBottom: '0.5rem',
            }}
            placeholder={strings.agePlaceholder}
            maxLength={2}
            showRedTriangle={!this.state.isEmpty && !this._validateAge()}
          />
          {this._renderAgeError()}
        </div>
        <div className={classes.Footer}>
          <Button
            disabled={!this._validateAge()}
            clicked={this.props.goToStep.bind(this, 4)}
          >
            {strings.next}
          </Button>
        </div>
      </div>
    );
  }
}
